import React from 'react'
import './styles/Conocenos.css'

const Conocenos = () => {
    return (
        <div id='conocenos'>
            <h2> Conócenos</h2>
            <div className='conocenos-text'>
            <p>Lorem ipsum dolor sit.</p>
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing el
            it. Quibusdam quas tenetur nostrum saepe unde exercitationem neque velit expedita excepturi repellat.</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Numquam impedit accusantium aliquam?</p>
            <p>Lorem Ipsun!</p>
            </div>
        </div>
    )
}

export default Conocenos
